import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.link.js";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { useSetting } from '@tencent/setting-vue-webpack-plugin';
import weixin from '@tencent/vft-common/weixin';
import { setTitle } from '../../utils/index';
var pageSetting = useSetting('页面配置', {
  页面标题: '',
  分享标题: '',
  分享描述: '',
  分享朋友圈标题: '',
  分享图: '',
  分享链接: ''
});
window.pageSetting = pageSetting;
export function setPageTitle(title) {
  var 页面标题 = pageSetting.页面标题;
  setTitle(title || 页面标题);
}
export function parseTemplate(str) {
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (str || '').replace(/\$\{(\w+)\}/g, function (s, $1) {
    return ctx[$1] || '';
  });
}
export function setShare() {
  var shareInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timeLineTitle = pageSetting.分享朋友圈标题,
      title = pageSetting.分享标题,
      imgUrl = pageSetting.分享图,
      desc = pageSetting.分享描述,
      link = pageSetting.分享链接;

  var info = _objectSpread({
    timeLineTitle: timeLineTitle,
    imgUrl: imgUrl,
    title: title,
    desc: desc,
    link: link
  }, shareInfo);

  var shareObj = {
    timeLineTitle: parseTemplate(info.timeLineTitle, data),
    imgUrl: info.imgUrl,
    title: parseTemplate(info.title, data),
    desc: parseTemplate(info.desc, data),
    link: info.link || window.location.href
  };
  setTimeout(function () {
    weixin.setAllShare(shareObj);
  }, 500);
  console.log(shareObj);
}